/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Search_ClientsInputs */

const en_users_form_search_clients = /** @type {(inputs: Users_Form_Search_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search clients by name or tax ID…`)
};

const pt_br2_users_form_search_clients = /** @type {(inputs: Users_Form_Search_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar clientes por nome ou CPF/CNPJ…`)
};

/**
* | output |
* | --- |
* | "Search clients by name or tax ID…" |
*
* @param {Users_Form_Search_ClientsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_search_clients = /** @type {((inputs?: Users_Form_Search_ClientsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Search_ClientsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_search_clients(inputs)
	return pt_br2_users_form_search_clients(inputs)
});